import React from 'react';
import PropTypes from 'prop-types';

import { Switch, withRouter, Redirect } from 'react-router-dom';

import AdvancedCommunicationsPage from './AdvancedCommunicationsPage';
import ProtectedRoute from '../../../components/ProtectedRoute';

const AdvancedCommunications = ({ location }) => (
    <Switch>
        <ProtectedRoute
            path="/admin/communications/:tab"
            component={AdvancedCommunicationsPage}
            permissions="adminFull"
        />
        <Redirect
            from="/admin/communications"
            to={{
                pathname: '/admin/communications/clients',
                search:   location.search
            }}
        />
    </Switch>
);

AdvancedCommunications.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired
};

export default withRouter(AdvancedCommunications);
